import axios from 'axios'

export default {
    getNotifications (context) {
        return axios.get('/api/notifications').then((response) => {
            context.commit('populateNotifications', response.data)
        })
    },

    readNotification ({ commit }, notification) {
        return axios.put(`/api/notifications/${notification.id}`).then((response) => {
            commit('removeNotification', response.data.id)
        })
    },

    readJobNotifications ({ commit }, jobId) {
        return axios.put(`/api/job/${jobId}/notifications`).then(() => {
            commit('removeJobNotifications', jobId)
        })
    },

    clearNotifications (context) {
        return axios.delete(`/api/notifications`).then(() => {
            context.commit('clearNotifications')
        })
    }
}
